import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls to top on route change, but preserves scroll position when using browser back/forward
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Check if this is a navigation (not back/forward)
    // Browser handles scroll restoration for back/forward automatically when using 'manual'
    if (window.history.scrollRestoration) {
      window.history.scrollRestoration = 'manual';
    }
    
    // Scroll to top on pathname change
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
